import React from 'react';
import { useEditorContext } from 'context/EditorContext';
import { useRouterContext } from 'hooks';

import { PageRenderer } from 'containers';
import PropTypes from 'prop-types';

const ThePage = ({ moduleToFocus }) => {
  const [{
    pageLiveData, pageLoading, pageError, screen,
  }] = useEditorContext();

  const {
    match: {
      params: { lang = 'pt' },
    },
  } = useRouterContext();

  if (pageLoading) return 'Loading';
  if (pageError) return 'Error';
  if (!pageLiveData) return 'Page empty';

  return (
    <PageRenderer
      page={pageLiveData}
      lang={lang}
      moduleToFocus={moduleToFocus}
      screen={screen}
    />
  );
};

ThePage.propTypes = {
  moduleToFocus: PropTypes.string,
};

ThePage.defaultProps = {
  moduleToFocus: null,
};

export default ThePage;
